export const statementClosingBalance = (row = {}) => Number(
  row.paymentSummary?.closingBalance ??
    row.paymentSummary?.balanceToPay ??
    row.closingBalance ??
    row.balance ??
    0,
);

export const isStatementSendEligible = () => true;

export const statementActionAvailability = (row = {}) => {
  const canSend = isStatementSendEligible(row);
  return {
    canSelect: canSend,
    canSend,
    canView: true,
    canDownload: true,
  };
};
